import { Store, select } from "@ngrx/store";
import { map, take, tap } from "rxjs/operators";

import { CHZone } from "@app/area/model/ch-zone";
import { CHZoneStateObj } from "../selectors/zones.selectors";
import { DeleteConfirmationService } from "@app/shared/components/delete-confirmation/delete-confirmation.service";
import { HttpResponseHandler } from "@app/shared/services/http-response-handler";
import { Injectable } from "@angular/core";
import { LoadingState } from "@app/root-store/api-result.state";
import { Observable } from "rxjs";
import { SnackbarActions } from "@app/root-store/actions";
import { State } from "@app/root-store/app.state";
import { ZoneActions } from "../actions";
import { ZoneSelectors } from "../selectors";

@Injectable({
    providedIn: "root",
})
export class ZoneDispatcher {
    constructor(private readonly store: Store<State>, private readonly deleteConfirmationService: DeleteConfirmationService) {}

    dispatchError(message: string) {
        this.store.dispatch(
            SnackbarActions.openSnackbar({
                message: new HttpResponseHandler(null, null, message, true),
            })
        );
    }

    getZoneState(): Observable<CHZoneStateObj> {
        return this.store.pipe(
            select(ZoneSelectors.selectZones),
            tap(result => {
                if (result?.uuid && result.callState === LoadingState.init) {
                    this.store.dispatch(ZoneActions.load({ uuid: result.uuid }));
                }
            })
        );
    }

    getZonesArray() {
        return this.getZoneState().pipe(map(zoneState => ZoneSelectors.selectSortedZonesArray(zoneState)));
    }

    deleteZone(uuid: string, zone: CHZone) {
        this.deleteConfirmationService
            .open$({ uuid, zone }, ZoneActions.deleteConfirmationDismiss, ZoneActions.deleteItem, zone.name)
            .pipe(take(1))
            .subscribe(action => {
                this.store.dispatch(action);
            });
    }

    upsertZone(uuid: string, zone: CHZone) {
        if (zone.id) {
            this.store.dispatch(ZoneActions.update({ uuid, zone }));
        } else {
            this.store.dispatch(ZoneActions.create({ uuid, zone }));
        }
    }

    clearZoneState() {
        this.store.dispatch(ZoneActions.clear());
    }
}
